import { Component, OnInit } from '@angular/core';
import { VtmnPlayButtonSizeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-size.enum';
import { TitleService } from '~/core/services/title/title.service';
import { ToggleNameEnum } from '~/toggles/services/toggle/enums/name.enum';

@Component({
  selector: 'app-failure',
  templateUrl: './failure.component.html',
})
export class FailureComponent implements OnInit {
  public readonly toggleNameEnum = ToggleNameEnum;
  public readonly vtmnPlayButtonSize = VtmnPlayButtonSizeEnum;

  constructor(private readonly titleService: TitleService) {}

  public ngOnInit(): void {
    this.titleService.setPageTitle('seo.checkout.failure.title');
  }
}
